<template>
  <div>
    <b-jumbotron header="Community Partners" lead="About">
      <div>
        Community partnership and engagement is an integral component in the translational research process, a key component of CHS translational teams, and part of our college’s mission of translating research of all types into positive community health outcomes. The development and maintenance of these partnerships requires accurate, up-to-date information accessible to all within our college. This database aims to bring all of this information into a single, easily searchable, and up-to-date platform.
      </div>
    </b-jumbotron>

    <b-jumbotron header="Faculty Workloads" lead="About">
      <div>
        Workload agreements are issued every spring semester for the following academic year. Workload agreements serve as a means of establishing expectations for faculty effort in the domains of research, teaching, service, and administration (if applicable). Faculty should work with their respective Assistant/Associate Dean to determine the most appropriate effort allocation given the faculty member’s track, rank, and grant coverage; this information is then communicated to degree coordinators for teaching assignments.
      </div>
    </b-jumbotron>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>
